// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-header-container[data-v-79ec04ba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding-right: 30px; /* 留出空間給預設的關閉按鈕 x */\n}\n.download-pdf-btn[data-v-79ec04ba] {\n  margin-left: auto;\n}\n", ""]);
// Exports
module.exports = exports;
